<template>
	<PopupRouterView label="Employee Level Input"  entityName="employeelevel" :documentId="mainRecordId"  @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="input-name" size="sm" :model.sync="model.name"   />
				<app-input-textbox id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="input-description" size="sm" :model.sync="model.description"   />
				<app-input-combobox-autocomplete :options="employeeLevels" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Parent" id="input-" size="sm" :model.sync="model.parentId"  :selected="model.parent != null ? model.parent.name : ''" @input="getEmployeeLevels" />
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import EmployeeLevel from '@/models/EmployeeLevel/EmployeeLevel';
import EmployeeLevelList from '@/models/EmployeeLevel/EmployeeLevelList';
import EmployeeLevelFilter from '@/filters/EmployeeLevel/EmployeeLevelFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputComboboxAutocomplete,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterEmployeeLevel : null,
			currentEmployeeLevelPage : 1,
			employeeLevelPageSize: 10,
			sortByEmployeeLevel: '',
			sortDescEmployeeLevel: '',
			employeeLevels: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getEmployeeLevel : async function(id) {
			this.isBusy = true;
			EmployeeLevel.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadEmployeeLevel = true;
			this.filterEmployeeLevel.id = this.modelId;
			EmployeeLevel.downloadDataDetail(this, this.filterEmployeeLevel).then(result => {
				this.isDownloadEmployeeLevel = false;
			}).catch(error => { this.isDownloadEmployeeLevel = false; })
		},
		getEmployeeLevels : async function(input) {
			let filter = new EmployeeLevelFilter();
			if (input != undefined) {
				filter.name = input;
			}
			EmployeeLevel.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.employeeLevels = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					EmployeeLevel.updateData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'employeelevelindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
			} else {
				EmployeeLevel.insertData(this, model).then(result => {
					this.$router.push({ name: 'employeelevelindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
			}
		},
		onHidden() {
			this.getEmployeeLevels();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterEmployeeLevel = new EmployeeLevelFilter();
		this.getEmployeeLevels();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getEmployeeLevel(id);
			} else {
				this.modelId = id;
				this.getEmployeeLevel(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
